
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import React, { useState, useEffect } from 'react';
import { AutoComplete } from 'primereact/autocomplete';
import { Calendar } from 'primereact/calendar';

import NumberFormat from 'react-number-format';

function renderFromHelper({ touched, error }) {
    if (!(error)) {
        return;
    } else {
        return <FormHelperText>{true && error}</FormHelperText>;
    }
};

function TextInputCharacter(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        if (newValue.match(/^[1-9]([A-Za-z0-9]*)+$/) || newValue.length === 0) {
            setStateVal(newValue); // only set when successful
        }

    };

    return (
        <TextField
            {...props}
            id={props.name}
            data-title={props.title ? props.title : ""}
            name={props.name}
            disabled={props.disabled}
            placeholder={""}
            value={stadoVal}
            onChange={onChange}
        />
    )

}

function TextInputNamesCharacter({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
}) {

    const onChange = (newValue) => {
        let response = newValue;
        //validamos que no tenga doble espacio ni inicie por uno 

        if (newValue.length > 0) {
            let ban = false;
            if (newValue.match(/^(?!.*  )[^\s].*$/)) {
                //validamos que no se hayan caracteres especiales ni tildes
                if (newValue.match(/^[A-Za-zñÑ]([A-Za-zñÑ\s]*)+$/) && newValue.match(/^[^áéíóúüÁÉÍÓÚÜ%¿;,.?#&]*$/)) {
                    //validamos que no se repítan las letras a excepcion de la L
                    if (newValue.match(/^(?!.*([a-zA-Z])\1{3,}).*$/)) {
                        ban = true; // only set when successful
                    }
                }

            }
            if (ban) {
                setStateVal(newValue)
                response = newValue; // only set when successful
            } else {
                response = stadoVal; // only set when successful
            }
        }
        return response;

    };

    const [stadoVal, setStateVal] = useState("");

    if (stadoVal !== input.value)
        input.value = onChange(input.value);

    return (
        <React.Fragment>
            <TextField
                placeholder={placeholder}
                label={placeholder}
                id={input.name}
                //data-title={props.title ? props.title :""}
                value={input.value}
                name={input.name}
                disabled={custom.disabled}
                className="text-razon-social"
                touched={touched}
                error={error}
                {...input}
                {...custom}

            />
            {renderFromHelper({ touched: touched, error: error })}
        </React.Fragment>
    )

}

function TextInputRazonSocialCharacter({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
}) {
    const onChange = (newValue) => {
        let response = newValue;


        if (newValue.length > 0) {
            let ban = false;
            //validamos que no tenga doble espacio ni inicie por uno 
            if (newValue.match(/^(?!.*  )[^\s].*$/) && newValue.match(/^(?!.*\s[a-zA-Z0-9ñÑ]\s[a-zA-Z0-9ñÑ]\s).*$/)) {
                //validamos que no se hayan caracteres especiales ni tildes
                if (newValue.match(/^[A-Za-z0-9ñÑ]([A-Za-z0-9ñÑ\s]*)+$/) && newValue.match(/^[^áéíóúüÁÉÍÓÚÜ%¿;,.?]*$/)) {
                    //validamos que no se repítan las letras a excepcion de la L
                    if (!newValue.match(/([a-zA-Z])\1{2,}/) && newValue.match(/^(?!.*([a-zA-Z])\1{2,}).*$/)) {
                        ban = true;
                    }

                }

            }
            if (ban) {
                setStateVal(newValue)
                response = newValue; // only set when successful
            } else {
                response = stadoVal; // only set when successful
            }
        }
        return response;

    };

    const [stadoVal, setStateVal] = useState("");

    if (stadoVal !== input.value)
        input.value = onChange(input.value);

    return (
        <React.Fragment>
            <TextField
                placeholder={placeholder}
                label={placeholder}
                id={input.name}
                //data-title={props.title ? props.title :""}
                value={input.value}
                name={input.name}
                disabled={custom.disabled}
                className="text-razon-social"
                touched={touched}
                error={error}
                {...input}
                {...custom}

            />
            {renderFromHelper({ touched: touched, error: error })}
        </React.Fragment>
    )

}

function OnlyTextInput(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        if (newValue.match(/^[A-Za-z0-9]([A-Za-z0-9\s]*)+$/) || newValue.length === 0) {
            setStateVal(newValue); // only set when successful
        }

    };

    return (
        <TextField
            {...props}
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            placeholder={""}
            value={stadoVal}
            onChange={onChange}
        />
    )

}

function OnlyNumberInput(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        if (newValue.match(/^[1-9]([0-9]*)+$/) || newValue.length === 0) {
            setStateVal(newValue); // only set when successful
        }

    };

    return (
        //<FormControl error={props.touched && !!props.error}>
        <React.Fragment>
            <TextField
                {...props}
                id={props.name}
                name={props.name}
                disabled={props.disabled}
                value={stadoVal}
                onChange={onChange}
                inputProps={{ maxLength: props.maxLength, minLength: props.minLength }}
                error={props.error ? true : false}
                label={props.placeholder}

            />
            {renderFromHelper({ touched: props.touched, error: props.error })}
        </React.Fragment>
        // </FormControl>
    )

}

function OnlyNumberPrefixInput(props) {
    const [stadoVal, setStateVal] = useState(props.value);

    const onChange = (e) => {
        const newValue = e.target.value;
        if (parseInt(newValue) > 0 || newValue.length === 0) {
            setStateVal(newValue); // only set when successful
        }

    };

    return (

        <NumberFormat
            {...props}
            prefix="$ "
            customInput={TextField}
            thousandSeparator={true}
            inputMode="numeric"
            id={props.name}
            name={props.name}
            allowNegative={false}
            allowLeadingZeros={false}
            inputProps={{ maxLength: props.maxLength, minLength: props.minLength }}
            disabled={props.disabled}
            // error={error ? true : false}
            label={props.placeholder}
            value={stadoVal}
            onChange={onChange}

        />
    )

}

function AutoCompleteDemo(props) {

    const [countries, setCountries] = useState([]);
    const [selectedCountry2, setSelectedCountry2] = useState("");
    const [filteredCountries, setFilteredCountries] = useState(null);

    useEffect(() => {
        setCountries(props.options)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const searchCountry = (event) => {
        setTimeout(() => {
            let _filteredCountries;
            if (!event.query.trim().length) {
                _filteredCountries = [...countries];
            }
            else {
                _filteredCountries = countries.filter((country) => {
                    return country.label.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCountries(_filteredCountries);
        }, 50);
    }

    return (
        <AutoComplete
            value={selectedCountry2}
            suggestions={filteredCountries}
            completeMethod={searchCountry}
            field="label"
            dropdown
            onChange={(e) => setSelectedCountry2(e.value)}
            aria-label="Countries"
            dropdownAriaLabel={props.placeholder}

            {...props}
            id={props.name}
            name={props.name}
            disabled={props.disabled}
            placeholder={props.placeholder}
        />

    )
}

function DateDemo(props) {
    const es = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: 'Hoy',
        dateFormat: 'dd/mm/yy',
        weekHeader: 'Sm'
    }
    const dateHoy = new Date();
    const [stadoVal, setStateVal] = useState(props.value);
    const [propsC, setPropsC] = useState(props);

    const onChange = (e) => {
        console.log(e, props)
        const newValue = e.target.value;
        if (newValue) setStateVal(newValue)
        let aux = propsC;
        aux.value = stadoVal;
        setPropsC(stadoVal)
        //}

    };

    return (
        <React.Fragment>
            <Calendar
                {...propsC}
                onFocus={onChange}
                locale={es}
                error={props.error ? true : false}
                placeholder={"yyyy-mm-dd"}
                dateFormat={"yy-mm-dd"}
                maxDate={dateHoy}
                id={props.name}
                name={props.name}
                readOnlyInput={false}
                monthNavigator
                yearNavigator
                yearRange="1900:2100"
                showIcon
                value={stadoVal}

            />

            {renderFromHelper({ touched: props.touched, error: props.error })}
        </React.Fragment>

    )
}

function MultipleSelector({
    label,
    input,
    placeholder,
    meta: { touched, invalid, error },
    ...custom
}) {

    console.log("Multiple Selector", custom, input)
    const [countries, setCountries] = useState(custom.options);
    const [selectedCountry2, setSelectedCountry2] = useState("");
    const [filteredCountries, setFilteredCountries] = useState(null);

    useEffect(() => {
        setCountries(custom.options)
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const searchCountry = (event) => {
        setTimeout(() => {
            let _filteredCountries;
            if (!event.query.trim().length) {
                _filteredCountries = [...countries];
            }
            else {
                _filteredCountries = countries.filter((country) => {
                    return country.label.toLowerCase().startsWith(event.query.toLowerCase());
                });
            }

            setFilteredCountries(_filteredCountries);
        }, 50);
    }

    return (
        <React.Fragment>
            <AutoComplete
                value={selectedCountry2}
                suggestions={filteredCountries}
                completeMethod={searchCountry}
                field="label"
                dropdown
                onChange={(e) => setSelectedCountry2(e.value)}
                aria-label="Countries"
                dropdownAriaLabel={placeholder}
                multiple
                id={input.name}
                name={input.name}
                disabled={input.disabled}
                placeholder={placeholder}
                error={error}
                {...input}
                {...custom}

            />
            {renderFromHelper({ touched: touched, error: error })}
        </React.Fragment>

    )


}

export { TextInputCharacter, MultipleSelector, AutoCompleteDemo, TextInputNamesCharacter, OnlyTextInput, OnlyNumberPrefixInput, OnlyNumberInput, DateDemo, TextInputRazonSocialCharacter };